import styled from "styled-components";
import emailIcon from "../../assets/at-details/email-icon.svg";
import phoneIcon from "../../assets/at-details/phone-icon.svg";
import adressIcon from "../../assets/at-details/adress-icon.svg";
import linkedinIcon from "../../assets/at-details/linkedin-icon.svg";

//Wrapper för allt
export const OuterContactContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	background-color: var(--contrastlight);
	margin: 0 auto;

	@media (min-width: 768px) {
		max-width: 860px;
		margin: 0 auto 20px auto;
	}

	@media (min-width: 1024px) {
		max-width: 1060px;
		margin: 0 auto 80px auto;
	}
`;
//en div som ligger runt text och ikoner med texter samt form
export const ContactWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;

	@media screen and (min-width: 768px) {
		flex-flow: row wrap;
		justify-content: space-between;
		gap: 30px;
	}

	@media screen and (min-width: 1024px) {
		display: flex;
		flex-flow: row wrap;
		padding: 0 100px;
		gap: 50px;
	}
`;
// div som ligger runt h1 och h3
export const TextWrapper = styled.div`
	display: flex;
	flex-direction: column;
	padding-top: 100px;
	width: 300px;

	@media screen and (min-width: 768px) {
		margin: 0 auto;
	}
	@media screen and (min-width: 1024px) {
		width: 100%;
	}
`;
// div som ligger runt alla ikoner med kontaktinfo
export const InfoWrapper = styled.div`
	margin: 30px auto 30px auto;

	@media screen and (min-width: 768px) {
		padding-top: 150px;
		margin: 30px auto 0 10px;
	}

	@media screen and (min-width: 1024px) {
		padding-top: 40px;
		margin: 0;
	}
`;

export const ContactH1 = styled.h1`
	font-size: 44px;
	color: var(--maindark);
	font-weight: 400;
	letter-spacing: 1px;

	@media screen and (min-width: 768px) {
		font-size: 54px;
		padding-bottom: 20px;
	}

	@media screen and (min-width: 1024px) {
		font-size: 64px;
	}
`;

export const ContactH3 = styled.h3`
	font-size: 14px;
	font-weight: 400;
	color: var(--maindark);
	letter-spacing: 1.7px;
	white-space: pre-line;
	margin: 15px 0;
	width: 320px;

	@media (min-width: 768px) {
		font-size: 18px;
		margin: 0;
		width: 350px;
	}

	@media (min-width: 1024px) {
		font-size: 20px;
		width: 100%;
	}
`;
//box för ikoner och kontakttext
export const ContactContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
	gap: 20px;
	width: 300px;

	@media screen and (min-width: 768px) {
		width: 100%;
	}

	@media screen and (min-width: 1024px) {
  margin-bottom: 5px;
	}
`;

export const ContactInfo = styled.a`
	color: var(--maindark);
	margin: 8px 0;
	font-weight: 400;
	font-size: 14px;
	letter-spacing: 1px;
	text-decoration: none;

	&:hover {
		text-decoration: underline;
		text-decoration-thickness: 2.5px;
		text-decoration-color: var(--bg-pink);
		text-underline-offset: 5px;
	}
`;
export const AdressContactInfo = styled.a`
	color: var(--maindark);
	margin: 8px 0;
	font-weight: 400;
	font-size: 14px;
	letter-spacing: 1px;
	text-decoration: none;
`;

export const StyledEmailIcon = styled.img.attrs({
	src: emailIcon,
	alt: "Email Icon",
})`
	width: 20px;
	height: 20px;
	filter: invert(1);
`;

export const StyledPhoneIcon = styled.img.attrs({
	src: phoneIcon,
	alt: "Phone Icon",
})`
	width: 20px;
	height: 20px;
	filter: invert(1);
`;

export const StyledAdressIcon = styled.img.attrs({
	src: adressIcon,
	alt: "Adress Icon",
})`
	width: 20px;
	height: 20px;
	filter: invert(1);
`;

export const StyledLinkedinIcon = styled.img.attrs({
	src: linkedinIcon,
	alt: "Bubble Icon",
})`
	width: 20px;
	height: 20px;
`;
